export interface StripeProduct {
  id: string;
  priceId: string;
  name: string;
  description: string;
  price: number;
  currency: string;
  currencySymbol: string;
  mode: 'payment' | 'subscription';
}

export interface StripeCoinProduct {
  priceId: string;
  name: string;
  description: string;
  mode: 'payment';
  price: number;
  currency: string;
  currencySymbol: string;
  coins: number;
  popular?: boolean;
}

export const stripeProducts: StripeProduct[] = [
  {
    id: 'prod_ScrWWOidqDhXg5',
    priceId: 'price_1RhbnhI1L3kMmnGGS4Xo1IZF',
    name: '600 teech Coins',
    description: 'Monthly subscription for 600 teech coins to power your interview practice',
    price: 4.99,
    currency: 'gbp',
    currencySymbol: '£',
    mode: 'subscription'
  },
  {
    id: 'prod_ScrVgdCESeQx6r',
    priceId: 'price_1RhbmWI1L3kMmnGGePEre7RB',
    name: '1500 teech Coins',
    description: 'Monthly subscription for 1500 teech coins to power your interview practice',
    price: 9.99,
    currency: 'gbp',
    currencySymbol: '£',
    mode: 'subscription'
  }
];

export const STRIPE_PRODUCTS = stripeProducts;

export const stripeCoinProducts: StripeCoinProduct[] = [
  {
    priceId: 'price_starter_coins',
    name: 'Starter Pack',
    description: 'Perfect for trying out the platform',
    mode: 'payment',
    price: 9.99,
    currency: 'usd',
    currencySymbol: '$',
    coins: 10,
  },
  {
    priceId: 'price_popular_coins',
    name: 'Popular Pack',
    description: 'Most popular choice for regular users',
    mode: 'payment',
    price: 19.99,
    currency: 'usd',
    currencySymbol: '$',
    coins: 25,
    popular: true,
  },
];

export const getProductByPriceId = (priceId: string): StripeProduct | undefined => {
  return stripeProducts.find(product => product.priceId === priceId);
};

export const getCoinProductByPriceId = (priceId: string): StripeCoinProduct | undefined => {
  return stripeCoinProducts.find(product => product.priceId === priceId);
};